import * as E from 'fp-ts/lib/Either'
import { pipe } from 'fp-ts/lib/pipeable'
import { sequenceT } from 'fp-ts/lib/Apply'

import { EuroCents } from '@espoon-voltti/ts-libs/lib/euro'

import {
  AP,
  apFirst,
  arrayV,
  metaPath,
  required,
  Validator,
  eurosInRangeV,
  nonEmptyArray
} from '@espoon-voltti/ts-libs/lib/validation'

import { Transaction } from '@espoon-voltti/nuora-domain/grants'
import { eurosMin, eurosMax, eurosTotalMin } from './constants'

export const transactionsV =
  (path: ReadonlyArray<string>): Validator<Transaction[], Transaction[]> =>
  (xs) => {
    const first = pipe(
      nonEmptyArray<Transaction>(metaPath(path))(xs),
      E.chain(arrayV(path, rowV))
    )
    const second = totalV(metaPath(path))(xs)
    return pipe(first, apFirst(second))
  }

const rowV =
  (path: ReadonlyArray<string>): Validator<Transaction, Transaction> =>
  (x) =>
    pipe(
      sequenceT(AP)(
        required([...path, 'description'])(x.description),
        eurosInRangeV([...path, 'amount'], eurosMin, eurosMax)(x.amount)
      ),
      E.map((_) => x)
    )

const totalV =
  (path: ReadonlyArray<string>): Validator<Transaction[], Transaction[]> =>
  (xs) =>
    pipe(
      eurosInRangeV(
        path,
        eurosTotalMin,
        eurosMax
      )(xs.reduce((acc, x) => acc.plus(x.amount), EuroCents.zero())),
      E.map((_) => xs)
    )
